<template>
  <div class="container" @mouseover="hover = true" @mouseleave="hover = false" @click="onClick">
    <div class="inner-container">
      <div v-if="!hover" class="card-action">
        <img :src="imgSrc" class="edit-icon" alt="edit" />
        {{ text }}
      </div>
      <div v-else class="card-action">
        <img src="@/assets/images/edit.png" class="edit-icon" alt="edit" />
        Edit Schedule
      </div>
    </div>
  </div>
</template>

<script>
import imgAll from '@/assets/images/call_flow_type_all.svg';
import imgWorking from '@/assets/images/call_flow_type_working.svg';
import imgNotworking from '@/assets/images/call_flow_type_no_working.svg';

export default {
  name: 'CallFlowCard',
  props: {
    type: String,
    texts: String,
    customStyle: String,
    onClick: Function
  },
  data() {
    return {
      hover: false
    };
  },
  computed: {
    text() {
      return this.type === 'all' ? 'Schedule (24/7)' : this.type === 'working' ? 'Working hours' : 'Non-working hours';
    },
    imgSrc() {
      return this.type === 'all' ? imgAll : this.type === 'working' ? imgWorking : imgNotworking;
    }
  }
};
</script>

<style scoped lang="scss">
.container {
  width: 320px;
  height: 56px;
  background: #e0e4eb;
  border-radius: 5px;
  cursor: pointer;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;

  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  letter-spacing: -0.02em;
  color: #606c82;
  box-shadow: 0px 2px 10px rgba(83, 95, 119, 0.15);
  border-radius: 5px;
  .edit-icon {
    width: 13px;
  }
  img {
    margin-right: 6px;
  }

  .card-action {
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
</style>
